import ApiService from './ApiService'
import endpointConfig from '@/configs/endpoint.config'
import type {
    SignInCredential,
    SignInotpCredential,
    SignotpCredential,
    SignUpCredential,
    ForgotPassword,
    ResetPassword,
    SignInResponse,
   
    SignInResponse1,
    SignUpResponse,
    empcodevaild,
    changepasswordsumbit,
    SignInQrcodeCredential
} from '@/@types/auth'

export async function apiSignIn(data: SignInCredential) {
    return ApiService.fetchDataWithAxios<SignInResponse>({
        url: endpointConfig.signIn,
        method: 'post',
        data,
    })
}


export async function apiSignInotp(data: SignInotpCredential) {
    return ApiService.fetchDataWithAxios<SignUpResponse>({
        url: endpointConfig.signIn,
        method: 'post',
        data,
    })
}





export async function apiSignIn1(data: SignInQrcodeCredential) {
    return ApiService.fetchDataWithAxios<SignInResponse1>({
        url: endpointConfig.signOut,
        method: 'post',
    })
}

export async function apiSignUp(data: SignUpCredential) {
    return ApiService.fetchDataWithAxios<SignUpResponse>({
        url: endpointConfig.signUp,
        method: 'post',
        data,
    })
}

export async function apiSignotp(data: SignotpCredential) {
    return ApiService.fetchDataWithAxios<SignInResponse>({
        url: endpointConfig.signotp,
        method: 'post',
        data,
    })
}
//empcodevaild
export async function apiempcodevaild(data: empcodevaild) {
    return ApiService.fetchDataWithAxios({
        url: endpointConfig.signOut,
        method: 'post',
    })
}

export async function apichangepassword(data: changepasswordsumbit) {
    return ApiService.fetchDataWithAxios({
        url: endpointConfig.signOut,
        method: 'post',
    })
}


export async function apiSignOut() {
    return ApiService.fetchDataWithAxios({
        url: endpointConfig.signOut,
        method: 'post',
    })
}

export async function apiForgotPassword<T>(data: ForgotPassword) {
    return ApiService.fetchDataWithAxios<T>({
        url: endpointConfig.forgotPassword,
        method: 'post',
        data,
    })
}

export async function apiResetPassword<T>(data: ResetPassword) {
    return ApiService.fetchDataWithAxios<T>({
        url: endpointConfig.resetPassword,
        method: 'post',
        data,
    })



        
}
